import { FIELD_TYPES } from "../shared/constants";

const { TEXT_FIELD, SELECT_FIELD } = FIELD_TYPES;

export const SITE_FILTER_OPTIONS = [
  {
    Name: "Address",
    ObjectId: `Address/${TEXT_FIELD}`
  },
  {
    Name: "City",
    ObjectId: `AddressCity/${TEXT_FIELD}`
  },
  {
    Name: "County",
    ObjectId: `AddressCounty/${TEXT_FIELD}`
  },
  {
    Name: "Post Code",
    ObjectId: `AddressPostCode/${TEXT_FIELD}`
  },
  {
    Name: "Phone Number",
    ObjectId: `PhoneNumber/${TEXT_FIELD}`
  },
  {
    Name: "Email",
    ObjectId: `Email/${TEXT_FIELD}`
  },
  {
    Name: "Client Name",
    ObjectId: `ClientName/${TEXT_FIELD}`
  },
  {
    Name: "Site Name",
    ObjectId: `SiteName/${TEXT_FIELD}`
  },
  {
    Name: "Status",
    ObjectId: `Status/${SELECT_FIELD}`
  },
  {
    Name: "Tags",
    ObjectId: `Tags/${SELECT_FIELD}`
  }
];

export const CONTACT_FILTER_OPTIONS = [
  {
    Name: "Contact Type",
    ObjectId: `ContactType/${SELECT_FIELD}`
  },
  {
    Name: "Personal Or Work",
    ObjectId: `PersonalOrWork/${SELECT_FIELD}`
  },
  {
    Name: "Description",
    ObjectId: `Description/${TEXT_FIELD}`
  },
  {
    Name: "Forename",
    ObjectId: `Forename/${TEXT_FIELD}`
  },
  {
    Name: "Surname",
    ObjectId: `Surname/${TEXT_FIELD}`
  },
  {
    Name: "Job Title",
    ObjectId: `JobTitle/${TEXT_FIELD}`
  },
  {
    Name: "Is Primary",
    ObjectId: `IsPrimary/${SELECT_FIELD}`
  },
  {
    Name: "Is Opt Out",
    ObjectId: `IsOptOut/${SELECT_FIELD}`
  },
  {
    Name: "Email available",
    ObjectId: `HasEmailAddresses/${SELECT_FIELD}`
  },
  {
    Name: "Phone number available",
    ObjectId: `HasPhoneNumbers/${SELECT_FIELD}`
  },
  {
    Name: "Address available",
    ObjectId: `HasAddresses/${SELECT_FIELD}`
  }
];

export const personalOrWorkOptions = [
  {
    Name: "Home",
    ObjectId: "Home"
  },
  {
    Name: "Work",
    ObjectId: "Work"
  },
  {
    Name: "PersonalMobile",
    ObjectId: "PersonalMobile"
  },
  {
    Name: "WorkMobile",
    ObjectId: "WorkMobile"
  },
  {
    Name: "Fax",
    ObjectId: "Fax"
  },
  { Name: "Personal", ObjectId: "Personal" }
];
